module.exports = __webpack_public_path__ + "static/media/removaDrone.4342caa6.png";